import { useContext } from 'react'

import { AppContext } from 'Services/AppContext'

export default function useAppContext() {
  return useContext(AppContext)
}
